<script setup lang="ts">
import { ref } from 'vue'
import './_index.scss'
import RoomieTag from '@lahaus-roomie/roomie/src/components/RoomieTag/index.vue'
import type { Props } from './types'
import AppCarrousel from '@/components/App/CarrouselV2/index.vue'

const props = defineProps<Props>()
const { buildImageUrl } = useImsImageProvider()
const currentAmenity = ref(0)
const carrouselImageSources = props.amenitiesData.map((object) => {
  const imageUrl = object.imageUrl
  return [
    {
      mediaWidth: 767,
      src: buildImageUrl(imageUrl, { width: 1000 })
    },
    {
      mediaWidth: 1023,
      src: buildImageUrl(imageUrl, { width: 1200 })
    },
    {
      mediaWidth: 2500,
      src: buildImageUrl(imageUrl, { width: 2000 })
    }
  ]
})

const updateCurrentAmenity = ref((index: any) => {
  currentAmenity.value = index
})

</script>

<script lang="ts">
export default {
  name: 'PdAmenitiesCarrousel'
}
</script>

<template>
  <section
    class="pd-amenities-carrousel relative">
    <AppCarrousel
      id="amenities-carrusel"
      :pictures-sources="carrouselImageSources"
      class="w-full h-360 md:h-450 lg:h-[58.4rem]"
      anchor-styles="w-full absolute left-0 top-1/2 -translate-y-1/2"
      img-styles="w-fit lg:w-auto max-w-fit lg:max-w-auto h-full"
      picture-container-styles="lg:rounded-24 gap-16 lg:gap-24 px-32 lg:px-120 h-full lg:h-auto"
      :figure-styles="{ aspectRatio: '2/1', borderRadius: '2.4rem', overflow: 'hidden' }"
      :image-multiplier="1"
      size-reverse
      :zoom="false"
      @image-scrolled="updateCurrentAmenity" />

    <div class="pd-amenities-tag flex flex-col gap-14">
      <RoomieTag
        id="pd-amenities-title-tag"
        class="h-fit w-fit"
        variant="success"
        :label="amenitiesData[currentAmenity].title" />

      <RoomieTag
        id="pd-amenities-description-tag"
        class="h-fit w-fit"
        variant="success"
        :label="amenitiesData[currentAmenity].description" />
    </div>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
